import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import { ref } from 'vue';
import { trlMessage } from '@/services/i18n';
import { ValidationField, ValidationFieldArray } from '@/components/ui/validate-form';
import ValidationErrors from '@/components/ui/validation-errors.vue';
import TotalPrice from '../components/total-price.vue';
import { getUser } from '@/utils/user';
import { UiButton, UiButtonIcon, UiInput, UiCheckbox, UiText, UiStack } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'event-participant',
    props: {
        fieldName: { default: 'participants' },
        disabled: { type: Boolean, default: false },
        isMe: { type: Boolean, default: false },
        price: { default: null },
        nominalPrice: { default: null },
        maxTicket: { default: null },
        canRemove: { type: Boolean, default: true },
        promoCode: { default: () => ({}) },
        eventId: { default: '' },
        tariffId: { default: null },
        showAttention: { type: Boolean, default: false }
    },
    emits: ["set-code"],
    setup(__props, { emit: __emit }) {
        const formFields = [
            {
                id: 'first_name',
                placeholder: trlMessage('profile.name')
            },
            {
                id: 'last_name',
                placeholder: trlMessage('profile.last_name')
            },
            {
                id: 'position',
                placeholder: trlMessage('profile.position')
            },
            {
                id: 'email',
                placeholder: trlMessage('profile.email')
            },
            {
                id: 'company',
                placeholder: trlMessage('profile.company')
            }
        ];
        const emit = __emit;
        const meValue = ref(false);
        function handleMeChange(operations, participant, value) {
            meValue.value = value;
            setCurrentUser(operations, participant, value);
        }
        function handleInsert(append) {
            const userData = {
                first_name: '',
                last_name: '',
                email: '',
                position: '',
                company: ''
            };
            append(userData);
        }
        function setCurrentUser(operations, participant, state) {
            const count = participant.length;
            const index = participant.findIndex((item) => item.email === '');
            const newUser = getUser();
            if (!state) {
                const removeIndex = participant.findIndex((item) => item.email === newUser.email);
                operations.remove(removeIndex);
                handleInsert(operations.append);
                return;
            }
            if (index !== -1) {
                operations.remove(index);
                operations.insert(index, newUser);
                return;
            }
            if (count < __props.maxTicket) {
                operations.append(newUser);
            }
        }
        function handleSetPromoCode(code) {
            emit('set-code', code);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ValidationFieldArray), {
                name: __props.fieldName,
                tag: "section"
            }, {
                default: _withCtx(({ fields, name, remove, insert, append }) => [
                    _createVNode(_unref(UiStack), {
                        gap: "s",
                        direction: "column"
                    }, {
                        default: _withCtx(() => [
                            (!__props.disabled)
                                ? _withDirectives((_openBlock(), _createBlock(_unref(UiCheckbox), {
                                    key: 0,
                                    disabled: __props.isMe,
                                    label: _unref(trlMessage)('event.go'),
                                    "model-value": meValue.value,
                                    "onUpdate:modelValue": (val) => handleMeChange({ insert, append, remove }, fields, val)
                                }, null, 8, ["disabled", "label", "model-value", "onUpdate:modelValue"])), [
                                    [_vShow, !__props.isMe]
                                ])
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: field.id,
                                    class: _normalizeClass(_ctx.$style.participant)
                                }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.$style.fields)
                                    }, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formFields, (userField, indexField) => {
                                            return _createVNode(_unref(ValidationField), {
                                                key: indexField,
                                                class: _normalizeClass(_ctx.$style.fieldWrapper),
                                                name: `${name}.${index}.${userField.id}`
                                            }, {
                                                default: _withCtx(({ id, modelValue, invalid, name, onChange }) => [
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.$style.inputWrapper)
                                                    }, [
                                                        _createVNode(_unref(UiInput), {
                                                            id: id,
                                                            title: userField.placeholder,
                                                            class: _normalizeClass(_ctx.$style.input),
                                                            disabled: __props.disabled || __props.isMe,
                                                            error: invalid,
                                                            name: name,
                                                            "model-value": modelValue,
                                                            "onUpdate:modelValue": onChange
                                                        }, null, 8, ["id", "title", "class", "disabled", "error", "name", "model-value", "onUpdate:modelValue"]),
                                                        _createVNode(ValidationErrors, {
                                                            name: `${name}`
                                                        }, null, 8, ["name"])
                                                    ], 2)
                                                ]),
                                                _: 2
                                            }, 1032, ["class", "name"]);
                                        }), 64))
                                    ], 2),
                                    (fields.length > 1 && __props.canRemove)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(_ctx.$style.buttonWrapper)
                                        }, [
                                            _createVNode(_unref(UiButtonIcon), {
                                                onClick: ($event) => (remove(index)),
                                                fill: "",
                                                icon: "trash",
                                                size: "xl",
                                                type: "danger"
                                            }, null, 8, ["onClick"])
                                        ], 2))
                                        : _createCommentVNode("", true)
                                ], 2));
                            }), 128)),
                            (__props.showAttention)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(_ctx.$style.attention)
                                }, [
                                    _createVNode(_unref(UiText), {
                                        kind: "accent",
                                        innerHTML: _unref(trlMessage)('ticket.single', { url: '/profile' })
                                    }, null, 8, ["innerHTML"])
                                ], 2))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style.total)
                            }, [
                                _createVNode(TotalPrice, {
                                    price: __props.price,
                                    "promo-code": __props.promoCode,
                                    "count-participants": fields.length,
                                    "nominal-price": __props.nominalPrice,
                                    editable: __props.canRemove,
                                    "event-id": __props.eventId,
                                    "tariff-id": __props.tariffId,
                                    onSetCode: handleSetPromoCode
                                }, null, 8, ["price", "promo-code", "count-participants", "nominal-price", "editable", "event-id", "tariff-id"]),
                                (__props.maxTicket > 1)
                                    ? (_openBlock(), _createBlock(_unref(UiButton), {
                                        key: 0,
                                        type: "secondary",
                                        size: "l",
                                        onClick: ($event) => (handleInsert(append)),
                                        disabled: fields.length >= __props.maxTicket
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(trlMessage)('event.add.person')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["onClick", "disabled"]))
                                    : _createCommentVNode("", true)
                            ], 2)
                        ]),
                        _: 2
                    }, 1024)
                ]),
                _: 1
            }, 8, ["name"]));
        };
    }
});
